import { render, staticRenderFns } from "./ArticleNormalCard.vue?vue&type=template&id=dfe1a92c&scoped=true&"
import script from "./ArticleNormalCard.vue?vue&type=script&lang=js&"
export * from "./ArticleNormalCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleNormalCard.vue?vue&type=style&index=0&id=dfe1a92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe1a92c",
  null
  
)

export default component.exports